// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"709da357","178":"ec2b7163","477":"b0cafa10","481":"61f3030b","538":"e0fa2b10","732":"12f12ad1","762":"60273b8d","770":"487867f6","807":"c6bcb1ff","954":"b5161260","992":"05e94d50"}[chunkId] + ".chunk.css";
};